/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], t = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], a = "Years", n = "Year", o = "Month", s = "Week", y = "Days", d = "Day", r = "Today", c = "No Event", u = "All day", l = "Delete", M = "Create an event", D = "dddd D{S} MMMM YYYY", b = {
  weekDays: e,
  months: t,
  years: a,
  year: n,
  month: o,
  week: s,
  days: y,
  day: d,
  today: r,
  noEvent: c,
  allDay: u,
  deleteEvent: l,
  createEvent: M,
  dateFormat: D
};
export {
  u as allDay,
  M as createEvent,
  D as dateFormat,
  d as day,
  y as days,
  b as default,
  l as deleteEvent,
  o as month,
  t as months,
  c as noEvent,
  r as today,
  s as week,
  e as weekDays,
  n as year,
  a as years
};
